import { extend } from '@thd-nucleus/data-sources';

import { PromotionDrawerProductPod } from '../components/PromoPod/PromotionDrawerProductPod';

export const PromoPodDataModel = extend(PromotionDrawerProductPod.dataModel);
